module.exports = __webpack_public_path__ + "img/17_Upper-rectrum.97c6f754.png";